import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "qcost_cookie_consent";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch (e) { console.error("cookie consent read failed", e); }
  }, []);

  useEffect(() => {
    const open = () => setShow(true);
    window.addEventListener("qcost:open-cookie", open);
    return () => window.removeEventListener("qcost:open-cookie", open);
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "1"); } catch (e) { console.error("cookie consent save failed", e); }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed bottom-0 inset-x-0 z-40 p-4 sm:p-6">
      <div className="max-w-3xl mx-auto bg-white border border-stone-200 rounded-sm shadow-2xl shadow-stone-900/10 p-5 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-brand/10 text-brand flex items-center justify-center shrink-0"><Cookie size={20} /></div>
        <p className="text-sm text-stone-600 leading-relaxed flex-1">
          Utilizziamo solo cookie tecnici necessari al funzionamento del servizio. Continuando la navigazione accetti il loro utilizzo. Maggiori dettagli nella{" "}
          <Link to="/cookie-policy" data-testid="cookie-banner-link" className="text-brand font-semibold hover:underline">Cookie Policy</Link>.
        </p>
        <button data-testid="cookie-banner-accept" onClick={accept} className="rounded-full bg-brand text-white px-6 py-2.5 text-sm font-semibold hover:bg-brand-hover transition-colors shrink-0">Ho capito</button>
      </div>
    </div>
  );
};
